import { useCallback } from 'react';
import { useNavigate, NavigateOptions } from 'react-router-dom';
import { useAuth } from '@smarty/shared';
import { storePath } from '@/config/routes.config';

/**
 * Navegación que antepone /store/:storeSlug a rutas del panel (Shopify-like).
 * Usar en páginas y componentes bajo store para que los enlaces sean correctos.
 */
export function useStoreNavigate() {
  const navigate = useNavigate();
  const { storeSlug } = useAuth();
  return useCallback(
    (path: string, options?: NavigateOptions) => {
      const target = storeSlug ? storePath(storeSlug, path) : path;
      navigate(target, options);
    },
    [navigate, storeSlug]
  );
}
